import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { PanelComponent } from './panel.component';

@Component({
    selector: 'app-panel-card',
    templateUrl: './panel-card.component.html',
    styleUrls: ['./panel-card.component.scss'],
    standalone: false
})
export class PanelCardComponent extends PanelComponent implements OnInit {
  ngOnInit() {
  }
}
